import { render, staticRenderFns } from "./OrderSearch.vue?vue&type=template&id=37af6bfd"
import script from "./OrderSearch.vue?vue&type=script&lang=ts"
export * from "./OrderSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.27_css-loader@6.11.0_webpack@5.92.0_esbuild@0._a350796feef9738eb472af7b4bb320e8/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports